import { createAction, props } from '@ngrx/store';

import { ReviewDetails } from '@ren/features/review/interfaces/review-details';
import { PaymentOptions } from '@ren/features/review/interfaces/payment-options';

export const loadReviewDetails = createAction(
  '[Review] Load Review Details',
  props<{reviewDetails: ReviewDetails}>()
);

export const updatePaymentOptions = createAction(
  '[Review] Update Payment Options',
  props<{paymentOptions: PaymentOptions}>()
);

export const cancelPolicy = createAction(
  '[RenewState] Cancel Policy'
);

export const cancelPolicySuccess = createAction(
  '[RenewState] Cancel Policy Success'
);

export const cancelPolicyFailed = createAction(
  '[RenewState] Cancel Policy Failed'
);

export type ReviewActionsUnion = ReturnType<typeof loadReviewDetails>;
